import React, { Component, PropTypes } from 'react';
import ResponsiveImage from 'components/ResponsiveImage';
import * as SvgIcons from 'components/Material/SvgIcons';
import { Units, Colors, Shadow } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    width: Units.keyline,
    height: Units.keyline,
    padding: Units.base,
    display: 'inline-block',
    verticalAlign: 'top',
    boxSizing: 'border-box',
    borderRadius: Units.base / 2,
    textAlign: 'center',
    // border: `solid 1px ${Colors.material.grey[300].hex}`,
    boxShadow: Shadow[1],
    cursor: 'pointer',
    overflow: 'hidden',
    transition: 'all ease 0.25s',
    ':hover': {
      boxShadow: Shadow[3]
    },
    '>SVG': {
      verticalAlign: 'middle'
    },
    '&responsive': {
      padding: 0
    },
    '&size2': {
      width: Units.keyline * 2,
      height: Units.keyline * 2,
      lineHeight: `${Units.keyline * 2 - Units.base * 2}px`
    },
    '&size3': {
      width: Units.keyline * 3,
      height: Units.keyline * 3,
      lineHeight: `${Units.keyline * 3 - Units.base * 2}px`
    },
    '&dir': {
      backgroundColor: Colors.material.lightBlue[400].hex
    }
  }
});

const styles = {
  avatar: {
    width: 48,
    height: 48
  }
};

class Thumb extends Component {
  static propTypes = {
    type: PropTypes.string,
    url: PropTypes.string,
    size: PropTypes.number,
    payload: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.array
    ]),
    onTouchTap: PropTypes.func
  };

  static defaultProps = {
    size: 1
  };

  handleTouchTap = () => {
    const { payload, onTouchTap } = this.props;
    onTouchTap && onTouchTap(payload);
  };

  renderIcon(type, size, url) {
    const style = {
      width: size * Units.keyline,
      height: size * Units.keyline
    };
    if (type === 'image') {
      return (
        <ResponsiveImage contain size={Units.keyline} style={style} src={url} />
      );
    } else if (type === 'video') {
      return <SvgIcons.AvMovie style={styles.avatar} />;
    } else if (type === 'audio') {
      return <SvgIcons.ImageAudiotrack style={styles.avatar} />;
    } else if (type === 'dir') {
      return (
        <SvgIcons.FileFolder color={Colors.darkWhite} style={styles.avatar} />
      );
    }
    return <SvgIcons.EditorInsertDriveFile style={styles.avatar} />;
  }

  render() {
    const { type, url, size } = this.props;
    const classes = classNames(css.root, css[`size${size}`], {
      [css.dir]: type === 'dir',
      [css.responsive]: type === 'image'
    });
    const icon = this.renderIcon(type, size, url);
    return (
      <div className={classes} onTouchTap={this.handleTouchTap}>
        {icon}
      </div>
    );
  }
}

export default Thumb;



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/Thumb.js